import { AbilityBuilder, Ability } from "@casl/ability";

/**
 * Fusionne les permissions par scope
 */
export const generateConsolidatedPermissions = (roles, scopes) => {
  const consolidated = {};
  if (!roles || typeof roles !== "object") return consolidated;
  if (!scopes || typeof scopes !== "object") return consolidated;

  Object.entries(scopes).forEach(([scopeName, scopeData]) => {
    consolidated[scopeName] = {};

    let scopeRoles = [];
    if (Array.isArray(scopeData.Roles)) scopeRoles = scopeData.Roles;
    else if (typeof scopeData === "string") scopeRoles = [scopeData];
    else if (scopeData && typeof scopeData.Roles === "object") scopeRoles = Object.values(scopeData.Roles);

    scopeRoles.forEach((roleId) => {
      const role = roles[roleId] || Object.values(roles).find((r) => r.id === roleId);
      if (!role) return;

      Object.entries(role).forEach(([module, sections]) => {
        if (typeof sections !== "object" || ["id", "displayName"].includes(module)) return;
        if (!consolidated[scopeName][module]) consolidated[scopeName][module] = {};

        Object.entries(sections).forEach(([section, actions]) => {
          if (!consolidated[scopeName][module][section]) {
            consolidated[scopeName][module][section] = { Create: false, Read: false, Update: false, Delete: false };
          }
          Object.keys(actions).forEach((key) => {
            consolidated[scopeName][module][section][key] =
              consolidated[scopeName][module][section][key] || actions[key];
          });
        });
      });
    });
  });
  return consolidated;
};

/**
 * Crée une CASL Ability multi-scope
 */
export const defineAbilityFromPermissions = (permissions) => {
  const { can, build } = new AbilityBuilder(Ability);
  if (!permissions || typeof permissions !== "object") return build();

  Object.entries(permissions).forEach(([scope, modules]) => {
    Object.entries(modules).forEach(([module, sections]) => {
      Object.entries(sections).forEach(([section, actions]) => {
        const subject = `${module}.${section}@${scope}`;
        if (actions.Read) can("read", subject);
        if (actions.Create) can("create", subject);
        if (actions.Update) can("update", subject);
        if (actions.Delete) can("delete", subject);
      });
    });
  });

  const ability = build();

  // 🧩 Debug log — affiche tous les sujets autorisés

  return ability;
};


/**
 * Helper pour générer le subject CASL
 */
export const subjectWithScope = (entity, section, scope) => `${entity}.${section}@${scope}`;
